var baseurl = (typeof baseurl === "undefined") ? '/' : baseurl;

(function ( $ ) 
{
	$.fn.message = function(text)
	{
		//$('.modal.fade.show').each(function () 
		//{
		//	var id = $(this).attr('id');

		//	$('#' + id).modal('hide');
		//});


		$('#message-mod .message').html(text);
		$(window).show_modal('#message-mod');
		
		return this;
	};

	$.fn.createSVG = function(selector)
	{
		$(selector).each(function () 
		{
		    var $img = $(this);
		    var imgID = $img.attr('id');
		    var imgClass = $img.attr('class');
		    var imgURL = $img.attr('src');

		    $.get(imgURL, function (data) {
		        // Get the SVG tag, ignore the rest
		        var $svg = $(data).find('svg');

		        // Add replaced image's ID to the new SVG
		        if (typeof imgID !== 'undefined') {
		            $svg = $svg.attr('id', imgID);
		        }
		        // Add replaced image's classes to the new SVG
		        if (typeof imgClass !== 'undefined') {
		            $svg = $svg.attr('class', imgClass + ' replaced-svg');
		        }

		        // Remove any invalid XML tags as per http://validator.w3.org
		        $svg = $svg.removeAttr('xmlns:a');

		        // Check if the viewport is set, else we gonna set it if we can.
		        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
		            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
		        }

		        $svg.attr('src', imgURL);

		        // Replace image with new SVG
		        $img.replaceWith($svg);
		    }, 'xml');
		});
		
		return this;
	};

 	$.fn.callbackOption = function(option,el)
 	{
 		switch(option)
 		{
 			case 'show-menu-mob':
 				$('#menu-mob').addClass('active');
 				break;

 			case 'hide-menu-mob':
 				$('#menu-mob').removeClass('active');
 				break;

 			case 'toggle-top-menu':
 				$('#menu-setting-site').toggleClass('active');
 				break;

 			case 'viewOrder':
 				var order_id = t.attr('data-id');

 				$.ajax(
 				{
 					type: 'POST',
 					method: 'POST',
 					cashe: false,
 					url: baseurl + 'profile',
 					data: { ajax: true, option: 'order', id: order_id }
 				})
 				.done(function (msg)
 				{
 					$('#orderMod .content').html(msg);
 					$('#orderMod').modal();
 					console.log(msg);
 				});

 				break;

 			case 'show-modal':
 				var target_modal = el.attr('href');

 				$(window).show_modal(target_modal);

 				break;

 			case 'insta':
 				let current_mod = $('#insta-mod');
 				
 				// галерея
 				let array_gallery = el.attr('data-gallery').replace(/\[/g, '').replace(/\]/g, '');

 				current_mod.find('.insta-mod-carousel-js')
						 				.trigger('destroy.owl.carousel')
						 				.removeClass('owl-loaded');
 				current_mod.find('.insta-mod-carousel-js')
						 				.html('');

 				if( array_gallery.length > 0 ){
 					array_gallery = array_gallery.split(',');

 					for(let i = 0; i < array_gallery.length; i++){
 						let img_src = array_gallery[i].replace(/\\/g, '').replace(/"/g, '');
 						let img = '<div class="wrapper-img"><img src="' + img_src + '"/></div>'
 						current_mod.find('.insta-mod-carousel-js').append(img);
 					}
 				} else{
 					let img_src = el.attr('data-image');
 					let img = '<div class="wrapper-img"><img src="' + img_src + '"/></div>'
 					current_mod.find('.insta-mod-carousel-js').append(img);
 				}
 				


 				var html_carousel_nav = '<div id="nav-container-insta-mod" class="nav-container">';
	 					html_carousel_nav += 	'<div id="dots-container-insta-mod" class="dots-container"></div>';
	 					html_carousel_nav += '</div>';
 				current_mod.find('.nav-div-js').html( html_carousel_nav );
 				current_mod.find('.insta-mod-carousel-js').owlCarouselStart();

 				// текст
 				current_mod.find('.text-js').html( el.attr('data-text') );

 				// теги
 				let tags = el.attr('data-tags').split(',');
 				current_mod.find('.hashtags-js').html('');
 				for(let i = 0; i < tags.length; i++){
 					current_mod.find('.hashtags-js').append('#' + tags[i] + ' ');
 				}


 				current_mod.find('.count-comment-js').html( el.attr('data-comments') );

 				current_mod.find('.time-js').html( el.attr('data-date') );

 				let href_insta = '//www.instagram.com/' + el.attr('data-account-username');
 				current_mod.find('.insta-subcribe-js').attr('href', href_insta);

 				$(window).show_modal('#insta-mod');
 				break;

 			default:
 				$(window).message('<p class="t-20"><b>Внимание</b></p><p>JavaScript событие <mark>' + option + '</mark> не найдено Х-(<br />Обратитесь к разработчику</p>');
 				break;
 		}
 		
 		return this;
 	};

 	$.fn.owlCarouselStart = function(autoplay)
 	{
 		autoplay = !autoplay ? true : autoplay;

 			this.find('img:not(.lazy)').each(function()
 			{
 				if($(this).attr('data-original'))
 				{
 					$(this).attr('src',$(this).attr('data-original'));
 					$(this).removeAttr('data-original');
 				}
 			});

 			if( this.hasClass('insta-mod-carousel-js') ){
 				$('.insta-mod-carousel-js').owlCarousel({
 				  loop: false,
 				  nav: true,
 				  dots: true,
 				  autoplay: false,
 				  margin: 20,
 				  navContainer: '#nav-container-insta-mod',
 				  dotsContainer: '#dots-container-insta-mod',
 				  items: 1
 				});

 				return false;
 			};

 			this.find('> .row').addClass('owl-carousel').addClass('mx-0');

 			var classList = this.find('.owl-carousel > div').eq(0).attr('class').split(/\s+/);
 			var cols = {};

 			for (var i = 0; i < classList.length; i++) 
 			{
 				if(classList[i].indexOf('col-xl') >= 0)
 				{
 					cols['1200'] = new Array;
 					cols['1200']['items'] = (12 / parseInt(classList[i].replace(/col-xl-/g,"")));
 					this.find('.owl-carousel > div').removeClass(classList[i]);
 				}
 				else if(classList[i].indexOf('col-lg') >= 0)
 				{
 					cols['992'] = new Array;
 					cols['992']['items'] = (12 / parseInt(classList[i].replace(/col-lg-/g,"")));
 					this.find('.owl-carousel > div').removeClass(classList[i]);
 				}
 				else if(classList[i].indexOf('col-md') >= 0)
 				{
 					cols['768'] = new Array;
 					cols['768']['items'] = (12 / parseInt(classList[i].replace(/col-md-/g,"")));
 					this.find('.owl-carousel > div').removeClass(classList[i]);
 				}
 				else if(classList[i].indexOf('col-sm') >= 0)
 				{
 					cols['576'] = new Array;
 					cols['576']['items'] = (12 / parseInt(classList[i].replace(/col-sm-/g,"")));
 					this.find('.owl-carousel > div').removeClass(classList[i]);
 				}
 				else if(classList[i].indexOf('col-') >= 0)
 				{
 					cols['0'] = new Array;
 					cols['0']['items'] = (12 / parseInt(classList[i].replace(/col-/g,"")));
 					this.find('.owl-carousel > div').removeClass(classList[i]);
 				}
 			}

 			if( this.hasClass('workers-carousel-js') ){
 				this.find('.owl-carousel').owlCarousel(
 				{
 					loop: true,
 					nav: true,
 					dots: true,
 					autoplay: true,
 					margin: 20,
 					navContainer: '#nav-container-workers',
 					dotsContainer: '#dots-container-workers',
 					responsive: cols
 				});
 				
 				return this;
 			}

 			if( this.hasClass('spec-carousel-js') ){
 				this.find('.owl-carousel').owlCarousel(
 				{
 					loop: true,
 					nav: true,
 					dots: true,
 					autoplay: true,
 					margin: 20,
 					navContainer: '#nav-container-spec',
 					dotsContainer: '#dots-container-spec',
 					responsive: cols
 				});
 				
 				return this;
 			}


 			if( this.hasClass('insta-carousel-js') ){
 				this.find('.owl-carousel').owlCarousel(
 				{
 					loop: true,
 					nav: true,
 					dots: true,
 					autoplay: false,
 					margin: 20,
 					navContainer: '#nav-container-insta',
 					dotsContainer: '#dots-container-insta',
 					responsive: cols
 				});
 				
 				return this;
 			}


 			if( this.hasClass('news-photo-carousel-js') ){
 				this.find('.owl-carousel').owlCarousel({
			    loop: false,
			    nav: true,
			    dots: true,
			    autoplay: false,
			    margin: 20,
			    // navContainer: '#nav-container-news-photo-js',
			    dotsContainer: '#dots-container-news-photo-js',
			    responsive: cols
			  });
 				
 				return this;
 			}



 			this.find('.owl-carousel > div').addClass('px-3');

 			this.find('.owl-carousel').owlCarousel(
 			{
 				loop: false,
 				nav: false,
 				dots: false,
 				autoplay: false,
 				margin: 20,
 				responsive: cols
 			});
 			
 			return this;
 	};

 	$.fn.show_modal = function(modal_selector){
 		let z_index = 1041;
 		$('body').find('.modal.show').each(function(){
 			$(this).css('z-index', ++z_index);
 		});

 		$(modal_selector).modal('toggle');

 		z_index = 1040;
 		$('body').find('.modal-backdrop.show').each(function(){
 			$(this).css('z-index', ++z_index);
 		});
 	};

}( jQuery ));



$.getScript(baseurl + "scripts/inputmask.js", function () 
{
	$.getScript(baseurl + "scripts/inputmask.extensions.js", function () 
	{
		$.getScript(baseurl + "scripts/inputmask.date.extensions.js", function () 
		{
			$.getScript(baseurl + "scripts/jquery.inputmask.js", function () 
			{
				
				$("form").find('input[name="phone"],input#phone').inputmask("+7 (999) 999-99-99");
				
				$("form").find('input[name="email"],input#email').inputmask("email");

				$("form").find('input.date').inputmask('99.99.9999');
			});
		});
		
	});
});

$(function()
{
	$('a[href="#"]').click(function(e)
	{
		e.preventDefault();
	});

	


});

$( window ).load(function()
{
	if($('iframe').length > 0)
	{
		var kk = new Array;

		$('iframe').each(function(index)
		{
			kk[index] = $(this).height() / $(this).width();
			$(this).css('max-width', '100%');
			$(this).css('height', $(this).width() * kk[index]);
		});

		$(window).resize(function()
		{
			$('iframe').each(function(index)
			{
				$(this).css('height', $(this).width() * kk[index]);
			});
		});
	}



	// $.getScript(baseurl + "scripts/jquery.scrollbar.min.js", function (){
	// });

});

// bootstrap 4
$.getScript(baseurl + "scripts/popper.min.js", function(){
	// $.getScript(SOURCES_JS + "bootstrap.min.js");
	$.getScript(baseurl + "scripts/util.js", function(){
		$.getScript(baseurl + "scripts/collapse.js");
		$.getScript(baseurl + "scripts/dropdown.js");
		$.getScript(baseurl + "scripts/modal.js", function(){

			//появление окна, если в него записали сообщение
				if($.trim($('#message-mod .message').text()).length > 0){
					var message_text = $.trim($('#message-mod .message').text());

					// if(message_text.indexOf('t-20') < 0)
					// 	message_text = '<p class="t-20"><b>Сообщение</b></p><p>' + message_text + '</p>';

					$(window).message(message_text);
				};
		});
	});
});

$(function(){
	if($.trim($('#message').text()).length > 0)
	{
		var message_text = $.trim($('#message').text());

		if(message_text.indexOf('t-20') < 0)
			message_text = '<p class="t-20"><b>Сообщение</b></p><p>' + message_text + '</p>';

		$(window).message(message_text);
	}

	$('body').on('click','.call-js',function(e)
	{
		e.preventDefault();

		var t = $(this);
		var option = !t.attr('data-option') ? 'form' : t.attr('data-option');

		$(window).callbackOption(option,t);
	});

	$('body').on('submit', 'form:not(.no-ajax)', function (e) 
	{
		var error = 0;
		var text = '';

		var form = $(this);

		$('.required:enabled,.r:enabled', this).each(function () 
		{
			if ($(this).attr('id') == 'agree' && !$(this).is(":checked")) 
			{
				$(window).message('<p class="t-20"><b>Внимание</b></p><p>Для продолжения необходимо принять условия обработки персональных данных.</p>');
					error++;
			}
			
			if ($(this).val().length < 1) 
			{
				var name = $(this).attr('name');
				var id = $(this).attr('id');

				if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';

				var tagname = $(this).prop("tagName");
				$(this).addClass('has-error');
				if (tagname == 'SELECT') {
					var select_id = $(this).attr('id') + '_chosen';
					$('#' + select_id + '.chosen-container').addClass('invalid');
				}
				error++;
			} 
			else if($(this).attr('name').indexOf('phone') >= 0)
			{
				var val = $(this).val();

				val = val.replace(/[^0-9]/gim,'');

				if(val.length != 11)
				{
					error++;
					$(this).addClass('has-error');
					if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';
				}
				else
					$(this).removeClass('has-error');
			}
			else if($(this).attr('name').indexOf('mail') >= 0)
			{
				var val = $(this).val();

				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

				if(!re.test(String(val).toLowerCase()))
				{
					error++;
					$(this).addClass('has-error');
					if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';
				}
				else
					$(this).removeClass('has-error');
			}
			else 
			{
				var tagname = $(this).prop("tagName");
				$(this).removeClass('has-error');
				if (tagname == 'SELECT') {
					var select_id = $(this).attr('id') + '_chosen';
					$('#' + select_id + '.chosen-container').removeClass('invalid');
				}
			}


		});

		$('input[type="checkbox"].required',this).each(function()
		{
			if($(this).attr('id').indexOf('agree') >= 0 && !$(this).is(":checked"))
			{
				text+= '- <b>Правила и оферту сайта!</b><br />';
				error++;
				$(this).addClass('has-error');
			}
		});

			if (error > 0) {
				if (text.length) {
					text = '<p class="t-20"><b>Произошла ошибка</b></p><p>Введенные вами данные не будут отправлены, так как не все обязательные поля были заполнены:</p><p>' + text + '</p>';
					$(window).message(text);
				}

				e.preventDefault();
			} else {
				var action = null;

				if ($(this).find('button[type="submit"]').length) action = $(this).find('button[type="submit"]').val();

				if ($('body').hasClass('checkout') || $('body').hasClass('profile_page') || action == 'register' || action == 'remind' || action == 'login' || $('body').hasClass('remind')) action = null;

				var form = $(this);

				if (action) 
				{
					e.preventDefault();

					$.ajax({
						type: 'POST',
						method: 'POST',
						cashe: false,
						url: '/',
						data: { ajax: true, option: action, query: $(this).serialize() }
					}).done(function (msg) {
						form.find("input[type=text], textarea").val("");

						var text = msg;

						if(!msg)
							text = '<p class="t-20"><b>Произошла ошибка</b></p><p>Ваше сообщение не было отправлено. Попробуйте сделать это позже.</p>';
						else if(msg && msg == 1)
						{
							$('.modal.fade.show').each(function () 
							{
								var id = $(this).attr('id');
							
								$('#' + id).modal('hide');
							});
							text = '<p class="t-20"><b>Спасибо!</b></p><p>Ваше сообщение было успешно отправлено. В ближайшее время с Вами свяжется наш менеджер для подтверждения заявки.</p>';
						}

						var message_text = $.trim(text);

						if(message_text.indexOf('t-20') < 0)
							message_text = '<p class="t-20"><b>Сообщение</b></p>' + message_text;

						$(window).message(message_text);

					});
				}
			}
	});

	
});


$.getScript(baseurl + "scripts/owl.carousel.min.js", function()
{
	$('.progress-carousel').owlCarousel(
	{
    items: 1,
    loop: true,
    nav: true,
    dots: false,
    autoplay: true
  });

  $('.main-banner-carousel').owlCarousel(
	{
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    autoplay: true
  });

  $('.awards').owlCarousel(
	{
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoWidth: true,
    margin: 20,
    responsive:{
    	0:    { items:3 },
			576:  { items:4 },
			768:  { items:5 },
			992:  { items:6 },
			1200: { items:7 }
    }
  });

  $(`.spec-carousel-js, .workers-carousel-js, 
  	.insta-carousel-js, .insta-mod-carousel-js, 
  	.news-photo-carousel-js`).each(function(){
  	$(this).owlCarouselStart();
  });

});
$.getScript(baseurl + "scripts/jquery.fancybox.min.js", function()
{
	$('.fancybox').fancybox();

	$('body').on('click', '.fancy-gallery-js', function(e){
		e.preventDefault();

		var href_array = [];
		
		$(this).find('span[data-src]').each(function(){
			var img_src = '';
			try {
				img_src = $(this).attr('data-src');
			} catch(e) {
				// console.log(e);
			}

			var img_caption = '';
			try {
				img_caption = $(this).attr('data-caption');
			} catch(e) {
				// console.log(e);
			}

			var img  = {};
			img.src  = img_src;
			img.type = 'image';
			img.opts = { 
				thumb 	: $(this).attr('data-src'),
				caption : img_caption
			};
			href_array.push( img );
		});

		$.fancybox.open( 
			href_array,
			{
				thumbs : {
					autoStart: true,
					axis : 'y'
				},
				mobile : {
					thumbs : {
						axis : 'x'
					},
					baseClass : 'fancybox-mobile-gallery'
				}
			}
		);
	});

	$('body').on('click', '.fancy-video-js', function(e){
		e.preventDefault();
		
		var href_video = $(this).attr('href');

		$.fancybox.open({
			src : href_video
		});
	});
});

$.getScript(baseurl + "scripts/jquery.dotdotdot.js",function()
{
	$('.dotdotdot').each(function()
	{
		$(this).dotdotdot();
	});
});

$.getScript(baseurl + "scripts/chosen.jquery.min.js", function(){
	$('select').chosen({
		disable_search_threshold: 10
	});

	// треугольник в select. если chosen не сработал, то показывать треугольник на css
	if( $('.chosen-container').length > 0 ){
		$('.small-triangle').css('display', 'none');
	}
});

$(window).load(function()
{
	$(window).createSVG('img.svg');

	$.getScript(baseurl + "scripts/snd.min.js", function (){
		$('.snd3').each(function(){
			var src_audio = '';
			try {
				src_audio = $(this).attr('data-src');
			} catch(e) {
				src_audio = baseurl + 'AC-DC - Money Talks.mp3';
				console.log(e);
			}
			
			$(this).snd( src_audio );
		});
	});


	$('body').on('change', '[name="font-size"]', function(){
		
		$('body').find('[name="font-size"]').each(function(){
			if( $(this).is(':checked') ){
				var font_size = $(this).attr('val');
				console.log(font_size);
				$('html').css('font-size', font_size);
				return;
			}
		});

	});

	$('body').on('change', '[name="color-theme"]', function(){
		var class_list = $('body').attr('class').split(' ');
		
		for(var i = 0; i < class_list.length; i++){
			if( class_list[i].indexOf('theme') != -1 ){
				$('body').removeClass(class_list[i]);
			}
		}
		
		$('body').addClass( $(this).attr('val') );
	});


	$('body').on('click', '.img-off-js', function(){
		if( $(this).hasClass('active') ){
			$('img:not(.not-hide-js)').css('display', 'block');
			$('.bg-image-off').removeClass('bg-image-off');

			$(this).removeClass('active');
			$(this).text('Выкл');
		} else{
			$('img:not(.not-hide-js)').css('display', 'none');
			$('html').find('*').each(function(){
				if( $(this).css('background-image').indexOf('url') != -1 ){
					$(this).addClass('bg-image-off');
				}
			});

			$(this).addClass('active');
			$(this).text('Вкл');
		}
	});

	$('body').on('change', '[name="letter-spacing"]', function(){
		var class_list = $('body').attr('class').split(' ');
		
		for(var i = 0; i < class_list.length; i++){
			if( class_list[i].indexOf('kerning') != -1 ){
				$('body').removeClass(class_list[i]);
			}
		}

		$('body').addClass( $(this).attr('val') );
	});


});


// WEBPACK FOOTER //
// ../scripts/sources/script.js